import { useEffect } from 'react';
import { api } from '@/lib/api';

const POLL_INTERVAL_MS = 30_000;

interface RemoteReloadListenerProps {
  municipalityId: string;
}

export const RemoteReloadListener = ({ municipalityId }: RemoteReloadListenerProps) => {
  useEffect(() => {
    const storageKey = `valderredible:reload-handled:${municipalityId}`;
    let checking = false;
    let disposed = false;

    const checkReloadStatus = async () => {
      if (checking || disposed) return;
      checking = true;

      try {
        const { reloadRequestedAt } = await api.municipalities.reloadStatus(municipalityId);
        if (!reloadRequestedAt || disposed) return;

        const requestedAt = Date.parse(reloadRequestedAt);
        const handledValue = window.localStorage.getItem(storageKey);
        const handledAt = handledValue ? Date.parse(handledValue) : Number.NaN;

        // Un tótem que arranca por primera vez ya está cargando la versión actual.
        if (!Number.isFinite(handledAt)) {
          window.localStorage.setItem(storageKey, reloadRequestedAt);
          return;
        }

        if (Number.isFinite(requestedAt) && requestedAt > handledAt) {
          // Guardar antes de recargar impide que una misma orden genere un bucle.
          window.localStorage.setItem(storageKey, reloadRequestedAt);
          window.location.reload();
        }
      } catch (error) {
        console.warn('No se pudo consultar la recarga remota del tótem', error);
      } finally {
        checking = false;
      }
    };

    void checkReloadStatus();
    const intervalId = window.setInterval(checkReloadStatus, POLL_INTERVAL_MS);
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') void checkReloadStatus();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      disposed = true;
      window.clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [municipalityId]);

  return null;
};
